import { render, staticRenderFns } from "./PageFilterButton.vue?vue&type=template&id=a80e9d26&scoped=true&"
import script from "./PageFilterButton.vue?vue&type=script&lang=ts&"
export * from "./PageFilterButton.vue?vue&type=script&lang=ts&"
import style0 from "./PageFilterButton.vue?vue&type=style&index=0&id=a80e9d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e9d26",
  null
  
)

export default component.exports